import { notification } from 'antd'

export const openNotificationWithIcon = (
  type: string,
  message: string,
  description: string
) => {
  // @ts-ignore
  notification[type]({
    message,
    description
  })
  const antNotification = document.getElementsByClassName(
    'ant-notification'
  )[0] as HTMLElement
  antNotification.style.zIndex = '1000020'
}
